(function () {
  var selector = '[data-deferred-section]';

  function hydrate(placeholder) {
    if (!placeholder || placeholder.dataset.deferredSectionLoaded === 'true') return;

    var template = placeholder.previousElementSibling;
    if (!template || !template.matches('[data-deferred-section-template]')) return;

    placeholder.dataset.deferredSectionLoaded = 'true';

    var fragment = template.content.cloneNode(true);
    var section = fragment.querySelector('[data-section-id]');
    template.replaceWith(fragment);
    placeholder.remove();

    if (section) {
      section.dispatchEvent(new CustomEvent('theme:deferred-section:load', { bubbles: true }));
    }
  }

  // Inserting a section (a full product grid) forces layout of the whole
  // subtree. With rootMargin 1000px a single scroll can bring several into view
  // at once, and hydrating them in one callback produced a ~2.4s long task.
  // Hydrate one per frame so the browser can paint and handle input between them.
  var queue = [];
  var draining = false;

  function schedule(callback) {
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(function () { callback(); });
    } else {
      window.setTimeout(callback, 0);
    }
  }

  function drain() {
    var placeholder = queue.shift();

    try {
      if (placeholder) hydrate(placeholder);
    } finally {
      // Keep draining even if one section fails to hydrate.
      if (queue.length) {
        schedule(drain);
      } else {
        draining = false;
      }
    }
  }

  function enqueue(placeholder) {
    if (!placeholder || placeholder.dataset.deferredSectionLoaded === 'true') return;
    if (queue.indexOf(placeholder) !== -1) return;

    queue.push(placeholder);
    if (draining) return;

    draining = true;
    schedule(drain);
  }

  function observe(root) {
    var placeholders = root.matches && root.matches(selector)
      ? [root]
      : Array.prototype.slice.call(root.querySelectorAll(selector));

    if (!('IntersectionObserver' in window)) {
      placeholders.forEach(enqueue);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        enqueue(entry.target);
      });
    }, { rootMargin: '1000px 0px' });

    placeholders.forEach(function (placeholder) {
      observer.observe(placeholder);
    });
  }

  function init() {
    observe(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
